import axios from 'axios'
import router from '../routes/index'
import Adjust from '@adjustcom/adjust-web-sdk'
import { getToken, getOs, getTokenFromStorage, removeToken, removeTokenFromStorage, getFbp, getFbc, getFbUserId} from './tool'
// import qs from 'qs'
const request = axios.create({
    baseURL: "/api1",
    timeout: 100000
})
const whiteList = ['/auth/contact2']
request.interceptors.request.use(function (config)  {
    // if(config.method!='get' && !config.needForm){
    //     config.data=qs.stringify(config.data);
    // }  
    if(config.customeHeaders) {
        for(let i in config.customeHeaders) {
            config.headers[i] = config.customeHeaders[i]
        }
    
    }
    // facebook fbp fbc
    let fbp = getFbp()
    let fbc = getFbc()
    let fb_user_id = getFbUserId()
    // adjust uuid
    let web_uuid = Adjust.getWebUUID()
    config.headers['web_uuid'] = web_uuid
    config.headers['os'] = `${getOs()}`
    config.headers['packageName'] = 'com.prana.lend.mascon.fintech.solution'
    config.headers['fbp'] = fbp || ""
    config.headers['fbc'] = fbc || ""
    config.headers['fbUserId'] = fb_user_id || ""
    config.headers['accept-language'] = "en"
    // config.headers['packageName'] = "com.lend.loan.prana.secure"
    config.noToken = config.noToken || false
    let token = getToken()
    
    if(!token) {
        token = getTokenFromStorage()
    }
    if(!token) {
        token = null
    }     
    if(config.token && !config.noToken) {
        token = config.token
    }
    if (token && !config.noToken) {                
        config.headers['token'] = token        
    } 
    return config
})
request.interceptors.response.use(function (data) {
    // debugger
    // const os = getOs()
    // if(os == 'other') {
    //     router.replace({
    //         path:"/alert"
    //     })
    // }        
    if(data.data.code == -4) {                  
        if( whiteList.indexOf(router.currentRoute.value.path) == -1 ) {
            removeToken()
            removeTokenFromStorage()     
            router.replace({
                path:"/login?_=1"
            })
        }                
    }
    return data.data
})
export default request